import script from "./config-consumption-row-v2.vue?vue&type=script&lang=jsx"
export * from "./config-consumption-row-v2.vue?vue&type=script&lang=jsx"

import "./config-consumption-row-v2.vue?vue&type=style&index=0&id=561cf81f&lang=scss"

const __exports__ = script;

export default __exports__